import { render, staticRenderFns } from "./AppCollapseCheck.vue?vue&type=template&id=36519f90&"
import script from "./AppCollapseCheck.vue?vue&type=script&lang=js&"
export * from "./AppCollapseCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports